import { observer } from 'mobx-react'
import './index.less'
import { useEffect, useRef, useState } from 'react'
import { Checkbox } from 'antd'
import * as Cesium from '@cesiumgs/cesium-analytics'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import IconPopup from './IconPopup'
import useStore from '@/hooks/useStore'

function MapLayer() {
  let mouseClickEvent: any = null
  let mouseMoveEvent: any = null
  let pick: any = null

  const layerListStore = useStore('layerList')
  const mapStore = useStore('mapStore')
  const facilityStore = useStore('facilityStore')
  const [aroundShow, setAroundShow] = useState(false)
  const [list1Show, setList1Show] = useState(false)
  const [list2Show, setList2Show] = useState(false)
  const [list3Show, setList3Show] = useState(false)
  const [list4Show, setList4Show] = useState(false)
  const [list5Show, setList5Show] = useState(false)
  const [layerListOne, setLayerListOne] = useState<Array<any>>([])
  const [layerListTwo, setLayerListTwo] = useState<Array<any>>([])
  const [layerListThree, setLayerListThree] = useState<Array<any>>([])
  const [layerListFour, setLayerListFour] = useState<Array<any>>([])
  const [layerListFive, setLayerListFive] = useState<Array<any>>([])

  const [currentClick, setCurrentClick] = useState<any>(null) // null: hide, have value: show
  const popupRef = useRef<any>(null)

  const list1 = [
    {
      name: '전체',
      type: 'All',
      checked: false,
      listKey: '1',
      node: '1',
      disabled: true,
    },
    {
      name: '농촌 관광',
      type: 'RURAL_TOURISM',
      checked: false,
      listKey: '1',
      node: '2',
      disabled: true,
    },
    {
      name: '농촌 숙박',
      type: 'RURAL_LODGING',
      checked: false,
      listKey: '1',
      node: '3',
      disabled: true,
    },
  ]
  const list2 = [
    {
      name: '전체',
      type: 'All',
      checked: false,
      listKey: '2',
      node: '1',
    },
    {
      name: '병원',
      type: 'HOSPITAL',
      checked: false,
      listKey: '2',
      node: '2',
    },
    {
      name: '약국',
      type: 'PHARMACY',
      checked: false,
      listKey: '2',
      node: '3',
    },
    {
      name: '초등학교',
      type: 'ELCH',
      checked: false,
      listKey: '2',
      node: '4',
    },
    {
      name: '중학교',
      type: 'MSUL',
      checked: false,
      listKey: '2',
      node: '5',
    },
    {
      name: '고등학교',
      type: 'HSCL',
      checked: false,
      listKey: '2',
      node: '6',
    },
    {
      name: '치안시설',
      type: 'Puborder',
      checked: false,
      listKey: '2',
      node: '7',
    },
    {
      name: '소방시설',
      type: 'Firefighting',
      checked: false,
      listKey: '2',
      node: '8',
    },
    {
      name: '관공서',
      type: 'Puboffice',
      checked: false,
      listKey: '2',
      node: '9',
    },
  ]

  const list3 = [
    {
      name: '전체',
      type: 'All',
      checked: false,
      listKey: '3',
      node: '1',
    },
    {
      name: '버스정류장',
      type: 'Busston',
      checked: false,
      listKey: '3',
      node: '2',
    },
    {
      name: '고속도로IC',
      type: 'Expressway',
      checked: false,
      listKey: '3',
      node: '3',
    },
    {
      name: '공용주차장',
      type: 'Prkplace',
      checked: false,
      listKey: '3',
      node: '4',
    },
  ]

  const list4 = [
    {
      name: '전체',
      type: 'All',
      checked: false,
      listKey: '4',
      node: '1',
    },
    {
      name: '숙박업',
      type: 'LodgingIndustry',
      checked: false,
      listKey: '4',
      node: '2',
    },
    {
      name: '음식점',
      type: 'Restaurant',
      checked: false,
      listKey: '4',
      node: '3',
    },
    {
      name: '전통시장',
      type: 'TraditionalMarket',
      checked: false,
      listKey: '4',
      node: '4',
    },
  ]

  const list5 = [
    {
      name: '전체',
      type: 'All',
      checked: false,
      listKey: '5',
      node: '1',
    },
    {
      name: '소매업',
      type: 'Retail',
      checked: false,
      listKey: '5',
      node: '2',
    },
    {
      name: '기술서비스',
      type: 'TechnicalService',
      checked: false,
      listKey: '5',
      node: '3',
    },
    {
      name: '사업서비스',
      type: 'BusinessService',
      checked: false,
      listKey: '5',
      node: '4',
    },
    {
      name: '교육서비스',
      type: 'EducationService',
      checked: false,
      listKey: '5',
      node: '5',
    },
    {
      name: '여가서비스',
      type: 'FiltrationService',
      checked: false,
      listKey: '5',
      node: '6',
    },
    {
      name: '수리서비스',
      type: 'RepairService',
      checked: false,
      listKey: '5',
      node: '7',
    },
    {
      name: '기타시설',
      type: 'OtherFacilities',
      checked: false,
      listKey: '5',
      node: '8',
    },
  ]

  useEffect(() => {
    setLayerListOne(list1)
    setLayerListTwo(list2)
    setLayerListThree(list3)
    setLayerListFour(list4)
    setLayerListFive(list5)
    if (mapStore.viewer) {
      layerListStore.init(mapStore.viewer)
    }
  }, [])

  useEffect(() => {
    if (!mapStore.viewer)
      return
    // 지도의 상태가 변경될 때마다 팝업창의 위치를 고정하기 위해서 updatePopupPosition 함수 이벤트 호출
    window.cviewer.scene.postRender.addEventListener(updatePopupPosition)

    mouseClickEvent = new Cesium.ScreenSpaceEventHandler(window.cviewer.scene.canvas)
    mouseMoveEvent = new Cesium.ScreenSpaceEventHandler(window.cviewer.scene.canvas)
    mouseClickEvent.setInputAction((movement: any) => {
      pick = window.cviewer.scene.pick(movement.position)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id) {
        // 주어진 속성 중 하나라도 존재하는지 확인
        const requiredProps = ['addr', 'hsptlSeCdNm', 'schoolNm', 'rdnmadr', 'fcltyNm', 'rnAdres', 'adres', 'exprnNm', 'exprnAddr', 'styiNm', 'nodeNm', 'bofficeNm', 'rteNm', 'prkplceTypeCdNm', 'bizesNm', 'rdnmAdr', 'mrktNm', 'roadNmAddr']
        const anyPropExists = requiredProps.some(prop => prop in pick.id)

        // pick.id값에 주변시설의 id가 있어야만 iconPopup 표출
        if (anyPropExists) {
          // 실제 pick한 primitive의 위치 데이터는 actualClampedPosition 에서 추출
          const positionClick = pick.primitive._actualClampedPosition
          const cartographic = Cesium.Cartographic.fromCartesian(positionClick)
          const longitude = Cesium.Math.toDegrees(cartographic.longitude)
          const latitude = Cesium.Math.toDegrees(cartographic.latitude)
          const windowCoord = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.cviewer.scene, Cesium.Cartesian3.fromDegrees(longitude, latitude, 0))
          // 팝업창의 위치, 팝업에 표시될 데이터 저장
          const obj = {
            sx: windowCoord.x - 180, // 좌측으로 이동
            sy: windowCoord.y - 125, // 위로 이동
            addr: pick.id.addr, // 주소데이터
            hsptlSeCdNm: pick.id.hsptlSeCdNm, // 병원 이름
            schoolNm: pick.id.schoolNm, // 학교이름
            rdnmadr: pick.id.rdnmadr, // 학교주소
            fcltyNm: pick.id.fcltyNm, // 치안시설, 소방시설, 관공서 이름
            rnAdres: pick.id.rnAdres, // 치안시설, 관공서 주소
            adres: pick.id.adres, // 소방시설 주소
            exprnNm: pick.id.exprnNm, // 농촌관광 이름
            exprnAddr: pick.id.exprnAddr, // 농촌관광 주소
            styiNm: pick.id.styiNm, // 농촌숙박 이름
            nodeNm: pick.id.nodeNm, // 버스정류장 이름
            bofficeNm: pick.id.bofficeNm, // 고속도로ic 이름
            rteNm: pick.id.rteNm, // 고속도로 이름
            prkplceTypeCdNm: pick.id.prkplceTypeCdNm, // 공영주차장 종류
            bizesNm: pick.id.bizesNm, // OpenAPI사용 데이터 이름
            rdnmAdr: pick.id.rdnmAdr, // OpenAPI사용 데이터 주소
            mrktNm: pick.id.mrktNm, // 전통시장 이름
            roadNmAddr: pick.id.roadNmAddr, // 전통시장 주소
          }
          setCurrentClick(obj)
        }
        else {
          setCurrentClick(null) // 주어진 속성이 하나도 없으면 팝업 숨김
        }
      }
      else {
        setCurrentClick(null) // 팝업숨김
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    mouseMoveEvent.setInputAction((movement: any) => {
      const hoverPick = window.cviewer.scene.pick(movement.endPosition)
      if (hoverPick && hoverPick.primitive && hoverPick.primitive instanceof Cesium.Billboard && hoverPick.id) {
        // 커서를 포인터로 변경
        document.body.style.cursor = 'pointer'
      }
      else {
        // 커서를 기본으로 되돌림
        document.body.style.cursor = 'default'
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }, [mapStore.viewer])

  // 팝업창 위치 고정
  const updatePopupPosition = () => {
    if (pick && pick.id && pick.primitive._actualClampedPosition) {
      const positionClick = pick.primitive._actualClampedPosition
      const cartographic = Cesium.Cartographic.fromCartesian(positionClick)
      const longitude = Cesium.Math.toDegrees(cartographic.longitude)
      const latitude = Cesium.Math.toDegrees(cartographic.latitude)
      const windowCoord = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.cviewer.scene, Cesium.Cartesian3.fromDegrees(longitude, latitude, 0))
      const obj = {
        sx: windowCoord.x - 180,
        sy: windowCoord.y - 125,
      }
      if (popupRef && popupRef.current) {
        popupRef.current.handleSetStyle && popupRef.current.handleSetStyle(obj)
      }
    }
  }

  const handleAround = () => {
    setAroundShow(!aroundShow)
    if (!aroundShow) {
      setList1Show(false)
      setList2Show(false)
      setList3Show(false)
      setList4Show(false)
      setList5Show(false)
    }
  }

  const listShow = (type: string) => {
    setList1Show(false)
    setList2Show(false)
    setList3Show(false)
    setList4Show(false)
    setList5Show(false)

    let selectedListShowState = false
    switch (type) {
      case 'list1':
        selectedListShowState = !list1Show
        setList1Show(selectedListShowState)
        break
      case 'list2':
        selectedListShowState = !list2Show
        setList2Show(selectedListShowState)
        break
      case 'list3':
        selectedListShowState = !list3Show
        setList3Show(selectedListShowState)
        break
      case 'list4':
        selectedListShowState = !list4Show
        setList4Show(selectedListShowState)
        break
      case 'list5':
        selectedListShowState = !list5Show
        setList5Show(selectedListShowState)
        break
    }
  }

  const checkListChange = (e: CheckboxChangeEvent, type: string, listKey: string, node: string) => {
    const isChecked = e.target.checked

    if (type === 'All') {
      checkAllNode(isChecked, listKey)
      setCurrentClick(null) // 팝업창 닫기
    }
    else {
      checkNode(isChecked, listKey, node)
      listTomap(isChecked, type)

      // 체크박스 해제 시 팝업창 닫기
      if (!isChecked && currentClick && type === currentClick !== null) {
        setCurrentClick(null) // 팝업창 닫기
      }
    }
  }

  const checkNode = (check: boolean, listKey: string, node: string) => {
    switch (listKey) {
      case '1':
        {
          const arr: Array<any> = []
          layerListOne.forEach((item) => {
            if (item.node === node) {
              item.checked = check
            }
            arr.push(item)
          })
          setLayerListOne(arr)
        }
        break
      case '2':
        {
          const arr: Array<any> = []
          layerListTwo.forEach((item) => {
            if (item.node === node) {
              item.checked = check
            }
            arr.push(item)
          })
          setLayerListTwo(arr)
        }
        break
      case '3':
        {
          const arr: Array<any> = []
          layerListThree.forEach((item) => {
            if (item.node === node) {
              item.checked = check
            }
            arr.push(item)
          })
          setLayerListThree(arr)
        }
        break
      case '4':
        {
          const arr: Array<any> = []
          layerListFour.forEach((item) => {
            if (item.node === node) {
              item.checked = check
            }
            arr.push(item)
          })
          setLayerListFour(arr)
        }
        break
      case '5':
        {
          const arr: Array<any> = []
          layerListFive.forEach((item) => {
            if (item.node === node) {
              item.checked = check
            }
            arr.push(item)
          })
          setLayerListFive(arr)
        }
        break
    }
  }

  const checkAllNode = (check: boolean, listKey: string) => {
    switch (listKey) {
      case '1':
        {
          const arr: Array<any> = []
          layerListOne.forEach((item) => {
            item.checked = check
            arr.push(item)
            listTomap(check, item.type)
          })
          setLayerListOne(arr)
        }
        break
      case '2':
        {
          const arr: Array<any> = []
          layerListTwo.forEach((item) => {
            item.checked = check
            arr.push(item)
            listTomap(check, item.type)
          })
          setLayerListTwo(arr)
        }
        break
      case '3':
        {
          const arr: Array<any> = []
          layerListThree.forEach((item) => {
            item.checked = check
            arr.push(item)
            listTomap(check, item.type)
          })
          setLayerListThree(arr)
        }
        break
      case '4':
        {
          const arr: Array<any> = []
          layerListFour.forEach((item) => {
            item.checked = check
            arr.push(item)
            listTomap(check, item.type)
          })
          setLayerListFour(arr)
        }
        break
      case '5':
        {
          const arr: Array<any> = []
          layerListFive.forEach((item) => {
            item.checked = check
            arr.push(item)
            listTomap(check, item.type)
          })
          setLayerListFive(arr)
        }
        break
    }
  }

  const listTomap = (check: boolean, type: string) => {
    if (check) {
      layerListStore.addLayerList(type, facilityStore.idlFcltUnqNo)
    }
    else {
      layerListStore.removeLayerList(type)
    }
  }

  const typeArr = [
    {
      name: '농촌관광·숙박',
      type: 'list1',
      children: (
        <ul className={'map-sub-list'} style={{ display: list1Show ? 'block' : 'none' }}>
          {layerListOne.map((item: any, index) => (
            <li key={`listone${index}`} className={'map-sub-item'}>
              <label className={`map-chk partOne${index}`}>{item.name}</label>
              <Checkbox
              checked={item.checked} onChange={e => checkListChange(e, item.type, item.listKey, item.node)} className={'map-checkBox'} />
            </li>
          ))}
        </ul>
      ),
    },
    {
      name: '주요시설',
      type: 'list2',
      children: (
        <ul className={'map-sub-list'} style={{ display: list2Show ? 'block' : 'none' }}>
          {layerListTwo.map((item: any, index) => (
            <li key={`listTwo${index}`} className={'map-sub-item'}>
              <label className={`map-chk partTwo${index}`}>{item.name}</label>
              <Checkbox checked={item.checked} onChange={e => checkListChange(e, item.type, item.listKey, item.node)} className={'map-checkBox'} />
            </li>
          ))}
        </ul>
      ),
    },
    {
      name: '교통',
      type: 'list3',
      children: (
        <ul className={'map-sub-list'} style={{ display: list3Show ? 'block' : 'none' }}>
          {layerListThree.map((item: any, index) => (
            <li key={`listThree${index}`} className={'map-sub-item'}>
              <label className={`map-chk partThree${index}`}>{item.name}</label>
              <Checkbox checked={item.checked} onChange={e => checkListChange(e, item.type, item.listKey, item.node)} className={'map-checkBox'} />
            </li>
          ))}
        </ul>
      ),
    },
    {
      name: '숙박·음식',
      type: 'list4',
      children: (
        <ul className={'map-sub-list'} style={{ display: list4Show ? 'block' : 'none' }}>
          {layerListFour.map((item: any, index) => (
            <li key={`listFour${index}`} className={'map-sub-item'}>
              <label className={`map-chk partFour${index}`}>{item.name}</label>
              <Checkbox checked={item.checked} onChange={e => checkListChange(e, item.type, item.listKey, item.node)} className={'map-checkBox'} />
            </li>
          ))}
        </ul>
      ),
    },
    {
      name: '기타시설',
      type: 'list5',
      children: (
        <ul className={'map-sub-list'} style={{ display: list5Show ? 'block' : 'none' }}>
          {layerListFive.map((item: any, index) => (
            <li key={`listFive${index}`} className={'map-sub-item'}>
              <label className={`map-chk partFive${index}`}>{item.name}</label>
              <Checkbox checked={item.checked} onChange={e => checkListChange(e, item.type, item.listKey, item.node)} className={'map-checkBox'} />
            </li>
          ))}
        </ul>
      ),
    },
  ]

  return (
    <div className={'MapLayer'}>
      <div className={'map-around'}>
        <button onClick={handleAround} type={'button'} className={'map-btn'}>
        <span translate="no"> 주변 시설</span>
        </button>
        {aroundShow
          ? (
            <ul className={'around-list'}>
              {typeArr.map((item: any, index) => (
                <li key={index} className={'around-item'}>
                  <button
                    onClick={() => {
                      listShow(item.type)
                    }}
                    className={`button${index}`}
                    type={'button'}
                  >
                    {item.name}
                  </button>
                  {item.children}
                </li>
              ))}
            </ul>
            )
          : null}
      </div>
      {currentClick && <IconPopup popupData={currentClick} ref={popupRef}></IconPopup>}
    </div>
  )
}

export default observer(MapLayer)
